import ContextMenu from '@ecp/common/src/components/contextmenu/ContextMenu';

ContextMenu.defaultProps = {
  blockAutoFocus: true,
};
export default ContextMenu;
